const QUEUED_ORDERS = "QUEUED_ORDERS";
const QUEUED_ORDERS_SUCCESS = "QUEUED_ORDERS_SUCCESS";
const QUEUED_ORDERS_FAILURE = "QUEUED_ORDERS_FAILURE";
const CLEAR_QUEUED_ORDERS = "CLEAR_QUEUED_ORDERS";

const QueuedOrdersSymbols = {
  QUEUED_ORDERS_SUCCESS,
  QUEUED_ORDERS_FAILURE,
  QUEUED_ORDERS,
  CLEAR_QUEUED_ORDERS,
};
export default QueuedOrdersSymbols;
